import { useTranslation } from 'next-i18next';
import { getStaticPaths, makeStaticProps } from '@/lib/getStatic';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import SEO from '@/components/SEO';
import Link from 'next/link';

const guides = [
  { lang: 'English',            path: '/guides/en' },
  { lang: 'Čeština',            path: '/guides/cs' },
  { lang: 'Deutsch',            path: '/guides/de' },
  { lang: 'Español',            path: '/guides/es' },
  { lang: 'Français',           path: '/guides/fr' },
  { lang: 'Polski',             path: '/guides/pl' },
  { lang: 'Slovenčina',         path: '/guides/sk' },
  { lang: 'Italiano',           path: '/guides/it' },
  { lang: 'Português',          path: '/guides/pt' },
  { lang: '中文',                path: '/guides/zh' },
  { lang: 'हिन्दी',              path: '/guides/hi' },
  { lang: 'العربية',             path: '/guides/ar' },
  { lang: '日本語',               path: '/guides/ja' },
  { lang: 'Bahasa Indonesia',   path: '/guides/id' },
  { lang: 'اردو',               path: '/guides/ur' },
  { lang: 'বাংলা',               path: '/guides/bn' },
  { lang: 'Magyar',             path: '/guides/hu' },
  { lang: 'Eesti',              path: '/guides/et' },
  { lang: 'Lietuvių',           path: '/guides/lt' },
  { lang: 'Ελληνικά',           path: '/guides/el' },
  { lang: 'Hrvatski',           path: '/guides/hr' },
  { lang: 'Latviešu',           path: '/guides/lv' },
  { lang: 'Nederlands',         path: '/guides/nl' },
  { lang: 'Suomi',              path: '/guides/fi' },
];

export default function GuidesPage() {
  const { t } = useTranslation('common');

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg)', color: 'var(--text)' }}>
      <SEO
        title={`${t('common:footer.guides')} - Penetrify`}
        description="Penetrify penetration testing guides in multiple languages."
      />
      <Navbar />

      <main style={{ paddingTop: '60px' }}>
        <section style={{ padding: '100px 0 120px' }}>
          <div style={{ maxWidth: '1140px', margin: '0 auto', padding: '0 24px' }}>
            {/* Header */}
            <div style={{ textAlign: 'center', marginBottom: '64px' }}>
              <p style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: '12px', fontWeight: 600, color: 'var(--accent)', textTransform: 'uppercase', letterSpacing: '2px', marginBottom: '16px' }}>Resources</p>
              <h1 style={{ fontSize: 'clamp(32px, 5vw, 52px)', fontWeight: 800, letterSpacing: '-1.5px', marginBottom: '16px', lineHeight: 1.1 }}>
                Security testing guides
              </h1>
              <p style={{ fontSize: '17px', color: 'var(--text-secondary)', maxWidth: '500px', margin: '0 auto', lineHeight: 1.65 }}>
                In-depth penetration testing guides available in 24 languages.
              </p>
            </div>

            {/* Grid */}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '8px', maxWidth: '900px', margin: '0 auto' }}>
              {guides.map(({ lang, path }) => (
                <Link
                  key={path}
                  href={path}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '16px 20px',
                    background: 'var(--bg-card)',
                    border: '1px solid var(--border)',
                    borderRadius: '12px',
                    textDecoration: 'none',
                    color: 'var(--text-secondary)',
                    fontSize: '15px',
                    fontWeight: 500,
                    transition: 'all 0.2s',
                  }}
                  onMouseEnter={e => {
                    const el = e.currentTarget as HTMLAnchorElement;
                    el.style.borderColor = 'var(--accent)';
                    el.style.color = 'var(--text)';
                    el.style.background = 'var(--bg-card-hover)';
                  }}
                  onMouseLeave={e => {
                    const el = e.currentTarget as HTMLAnchorElement;
                    el.style.borderColor = 'var(--border)';
                    el.style.color = 'var(--text-secondary)';
                    el.style.background = 'var(--bg-card)';
                  }}
                >
                  <span>{lang}</span>
                  <svg style={{ width: '14px', height: '14px', opacity: 0.4, flexShrink: 0 }} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                  </svg>
                </Link>
              ))}
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}

const getStaticProps = makeStaticProps(['common']);
export { getStaticPaths, getStaticProps };
